module.exports = __webpack_public_path__ + "img/tp-cand-ss.8b0ba329.svg";